"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _awsAmplify = require("aws-amplify");
var _react = _interopRequireDefault(require("react"));
var _PageHeading = _interopRequireDefault(require("../components/PageHeading"));
var _Paragraph = _interopRequireDefault(require("../components/Paragraph"));
var _RicePaper = _interopRequireDefault(require("../components/RicePaper"));
var _useBreadcrumbs = _interopRequireDefault(require("../hooks/use-breadcrumbs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PAGE_TITLE = '401 - Unauthorized';
const HttpInternalServerError = () => {
  (0, _useBreadcrumbs.default)([{
    label: 'Home',
    href: '/'
  }]);
  return /*#__PURE__*/_react.default.createElement(_Paragraph.default, null, /*#__PURE__*/_react.default.createElement(_PageHeading.default, {
    title: PAGE_TITLE
  }), /*#__PURE__*/_react.default.createElement(_RicePaper.default, {
    sx: {
      maxWidth: 'sm',
      width: '80%',
      margin: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    gutterBottom: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    translate: "no"
  }, "Jogai"), " (", /*#__PURE__*/_react.default.createElement("span", {
    lang: "ja"
  }, "\u9664\u5916"), ")\u2026you need to sign in."), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    paragraph: true
  }, "Only authenticated users can access this resource. Please", ' ', /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: "",
    onClick: event => {
      event.preventDefault();
      _awsAmplify.Auth.federatedSignIn();
    }
  }, "sign in"), ".")));
};
HttpInternalServerError.defaultProps = {};
var _default = exports.default = HttpInternalServerError;